import { EpimsBaseEntityDto } from './epim-base.dto';
export class DocumentTypeDto extends EpimsBaseEntityDto {

    DocumentTypeId: string;

     DocumentTypeName: string;
    // SubscriptionUserId: string;
     SubscriberId: string;
    // dateCreated: Date;
    // dateUpdated?: Date;
    // CreatedById: string;
    // ModifiedById: string;
    // SiteId: string;
    // Version: number;
   

}